import React, { useCallback } from 'react';
import {
  ResizablePanelGroup,
  ResizablePanel,
  ResizableHandle,
} from '../ui/resizable';
import Sidebar from './Sidebar';
import ContentArea from './ContentArea';
import FloatingActions from '../FloatingActions';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { useAuth } from '../../contexts/AuthContext';
import LoginPage from '../LoginPage';

const DashboardLayout = () => {
  const { user, loading } = useAuth();
  // Сохраняем размер сайдбара в localStorage
  const [sidebarSize, setSidebarSize] = useLocalStorage('sidebar-size', 20);

  // Обработчик изменения размера панелей
  const handleLayout = useCallback((sizes) => {
    if (sizes && sizes.length > 0) {
      setSidebarSize(sizes[0]);
    }
  }, [setSidebarSize]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <div className="h-full w-full relative">
      <ResizablePanelGroup 
        direction="horizontal" 
        className="h-full"
        onLayout={handleLayout}
      >
        <ResizablePanel 
          defaultSize={sidebarSize} 
          minSize={15} 
          maxSize={35}
        >
          <div className="h-full bg-sidebar border-r border-border">
            <Sidebar />
          </div>
        </ResizablePanel>
        <ResizableHandle withHandle />
        <ResizablePanel defaultSize={100 - sidebarSize}>
          <div className="h-full bg-background overflow-y-auto">
            <ContentArea />
          </div>
        </ResizablePanel>
      </ResizablePanelGroup>
      
      {/* Плавающие кнопки */}
      <FloatingActions />
    </div>
  );
};

export default DashboardLayout;
